/* Important Info component acc page */
import React from 'react';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "../../styles/Account.module.css";

const InfoSup = () => {
  return (
    <div className="mb-5 px-3">
        <Row className="my-3">
        <Col md={{span: 10, offset: 1}}>
        <div className={`px-3 py-2 ${styles.SubTitle6 }`}>
          <h5 className={`${styles.Blue} text-center`}>SERCICE DESK INFO</h5>
          <hr className={`mt-2 mb-0`}/>

          <p className={`pt-1`}>
          <span className={`${styles.Blue}`}>*</span> Create a ticket for Billing 
          or technical issues.
          </p>
          <p className={`pt-1`}>
          <span className={`${styles.Blue}`}>*</span> If the question relates to functionality
          please read the Info boxes on the related page and watch the tutorial first.
          </p>
          <hr className={`mt-2 mb-0`}/>
         </div> 
        </Col>
      </Row>
    </div>
  )
}

export default InfoSup